// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sispessoal-modulo-wrapper{min-height:calc(100vh - 275.25px);max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content}#sispessoal-modulo-progress .progress{margin:0;border-radius:0}", ""]);
// Exports
module.exports = exports;
